import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { HAR_MARKET_GROUPS } from "../lib/harMarketAreas";

const TYPES = [
  "All",
  "Single Family Residence",
  "Condominium",
  "Mid/Hi-Rise Condominium",
  "Townhouse",
  "Duplex",
  "Multi-Family",
  "Country Homes/Acreage",
  "Residential Lots & Land",
];
const PRICES = [
  { label: "Any Price", value: "" },
  { label: "Under $500K", value: "0-500000" },
  { label: "$500K – $1M", value: "500000-1000000" },
  { label: "$1M – $2M", value: "1000000-2000000" },
  { label: "$2M – $5M", value: "2000000-5000000" },
  { label: "$5M+", value: "5000000-99999999" },
];

export default function SearchBar({ variant = "hero" }) {
  const navigate = useNavigate();
  const [city, setCity] = useState("All");
  const [type, setType] = useState("All");
  const [price, setPrice] = useState("");

  const submit = (e) => {
    e?.preventDefault();
    const params = new URLSearchParams();
    if (city && city !== "All") params.set("city", city);
    if (type && type !== "All") params.set("property_type", type);
    if (price) {
      const [mn, mx] = price.split("-");
      if (mn) params.set("min_price", mn);
      if (mx) params.set("max_price", mx);
    }
    navigate(`/properties?${params.toString()}`);
  };

  const isHero = variant === "hero";

  return (
    <form
      onSubmit={submit}
      className={`${
        isHero ? "bg-white/95 backdrop-blur-md" : "bg-white border border-stone-200"
      } p-3 sm:p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 shadow-2xl shadow-black/30`}
      data-testid="search-bar"
    >
      <Field label="Market Area">
        <select
          value={city}
          onChange={(e) => setCity(e.target.value)}
          className="w-full bg-transparent text-sm font-medium focus:outline-none"
          data-testid="search-neighborhood"
        >
          <option value="All">All Houston Metro</option>
          {HAR_MARKET_GROUPS.map((g) => (
            <optgroup key={g.label} label={g.label}>
              {g.cities.map((c) => (
                <option key={c} value={c}>{c}</option>
              ))}
            </optgroup>
          ))}
        </select>
      </Field>
      <Field label="Property Type">
        <select
          value={type}
          onChange={(e) => setType(e.target.value)}
          className="w-full bg-transparent text-sm font-medium focus:outline-none"
          data-testid="search-type"
        >
          {TYPES.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
      </Field>
      <Field label="Price Range">
        <select
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          className="w-full bg-transparent text-sm font-medium focus:outline-none"
          data-testid="search-price"
        >
          {PRICES.map((p) => (
            <option key={p.label} value={p.value}>{p.label}</option>
          ))}
        </select>
      </Field>
      <button
        type="submit"
        className="bg-[#0A0A0A] hover:bg-[#E63946] text-white font-medium uppercase tracking-[0.25em] text-xs flex items-center justify-center gap-2 py-4 px-6 transition-colors"
        data-testid="search-submit"
      >
        <Search className="w-4 h-4" strokeWidth={1.75} />
        Search Homes
      </button>
    </form>
  );
}

function Field({ label, children }) {
  return (
    <div className="bg-stone-50 px-5 py-3">
      <div className="eyebrow text-gray-500 mb-1">
        {label}
      </div>
      {children}
    </div>
  );
}
